import React from "react";
import Layout from "../../Layout";
import MyGroups from "../../components/MyGroups";
import TabPane from "../../components/TabPane";
import Title from "../../components/Title";
import {
  CREATE_GROUP,
  GET_GROUPS_BY_ADMIN,
  GET_GROUPS_BY_MEMBER,
  GET_GROUPS_BY_MODERATOR,
  GROUP_SELECT_COMMUNITY,
  ROOT,
} from "../../constants/api";
import useLoggedIn from "../../hooks/useLoggedIn";
import { Link } from "react-router-dom";
import { Avatar } from "@mui/material";
import CreateGroupIcon from "@images/createGroup.svg";
import { useSelector } from "react-redux";

function GroupManagement() {
  useLoggedIn();

  const { userRecord } = useSelector((state) => state.user);

  const tabs = ["My Groups", "Moderated Groups"];

  const createGroupLink = userRecord?.joinedCommunities?.length === 1 ? CREATE_GROUP : GROUP_SELECT_COMMUNITY;

  return (
    <Layout>
      <Title back={ROOT}>Group Management</Title>
      <MyGroups
        noPending
        get_url={GET_GROUPS_BY_MEMBER}
        getGroupSubtext={group => {
          if(userRecord?.groupsAdmin?.some((g) => g?.id === group?.id))
            return "Creator";

          if(userRecord?.groupsSharedAdmin?.some((g) => g?.id === group?.id))
            return "Admin";

          return "Member";
        }}
      />
      {/* <TabPane tabs={tabs}>
        <div>
          <MyGroups
            noPending
            get_url={GET_GROUPS_BY_ADMIN}
            getGroupSubtext={group => {
              if()
              return group?.visibility;
            }}
          />
        </div>
        <div>
          <MyGroups
            noPending
            get_url={GET_GROUPS_BY_MODERATOR}
          />
        </div>
      </TabPane> */}
      <div className="fixed bottom-10 right-5 md:right-1/4">
        <Link to={createGroupLink}>
          <Avatar
            className=" h-12 w-12 md:h-20 md:w-20"
            src={CreateGroupIcon}
          />
        </Link>
      </div>
    </Layout>
  );
}

export default GroupManagement;
